var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.rowvalue === null)?_c('strong',{class:_vm.ClassObject},[_vm._v(" Sin Contrato ")]):_c('strong',{class:_vm.ClassObject},[_vm._v(" "+_vm._s(_vm.rowvalue)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }